import React from 'react';

const TopCruiseDetailSection = (prop) => {

    const defaultImage = 'https://travel-img-assets.s3.us-west-2.amazonaws.com/no-image/no-image-500x300.png';
    const topCruises = prop.topCruises;
    const topItems = prop.topItems;
    const dataItem = prop.dataItem;

    return (
        <>
           {topCruises ?
                <>
                    { topItems !== undefined && topItems !== null && topItems.length > 0  ?
                        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 mb-3 gutter-10">
                            {topItems.map((item, key) => {
                                const currentImgNo = key + 1;
                                if(item.name != undefined ) {
                                    return (
                                        <>
                                            <div className="col-6 col-sm-6 col-xl col-lg-4 col-md-4 mb-3 mb-xl-0 py-1">
                                                <div className={`${dataItem == 'lines' ? 'rounded-4 box-shadow-md p-2 pt-4':'rounded-sm'}`}>
                                                    <span className="counter-circle-list rounded-circle center position-absolute z-index-1 font-weight-bold">
                                                        {currentImgNo}
                                                    </span>
                                                    <button className="btn-unstyled deal-list-card text-decoration-none" style={{cursor: "default"}}>
                                                        <div className="position-relative w-100 overflow-hidden">
                                                            <img className={`w-100 ${dataItem == 'lines' ? 'object-fit-contain' : 'object-fit-cover' } rounded-4`} width="170" height="170" src={(item.image != undefined && item.image != '') ? item.image : defaultImage} data-was-processed="true" />
                                                            { dataItem == 'ships' || dataItem == 'lines' ? null :
                                                                <div className="position-absolute left-bottom py-2 px-2 rounded-sm bg-black-transparent">
                                                                    <h6 className="text-white text-center mb-0 font-size-md">
                                                                        {(item.long != undefined && item.long != '') ? (item.name + ' in ' + item.long) : item.name}
                                                                    </h6>
                                                                </div> 
                                                            }
                                                        </div>
                                                        { dataItem == 'ships' ?
                                                            <div className="mt-2 left-bottom py-2 px-2 rounded-sm bg-black-transparent">
                                                                <h6 className="text-white text-center mb-0 font-size-md">
                                                                    {(item.long != undefined && item.long != '') ? (item.name + ' in ' + item.long) : item.name}
                                                                </h6>
                                                            </div>
                                                        : null }
                                                    </button>
                                                </div>
                                            </div>
                                        </>
                                    );
                                }  
                            })}
                        </div>
                    :  null }
                </>
            : null }
        </>
    );
};

export default TopCruiseDetailSection;
